'use strict';

// Webpack automatically resolves and parses the JSON file into a JS object
import configData from '../../config.json';

// Manually recreate the module that gulp-ng-config used to build
angular
    .module('prism-ui.config', [])
    .constant('appUriConfig', configData.appUriConfig);
